// Generated by ReScript, PLEASE EDIT WITH CARE

import * as RescriptJsonUtils$Showside from "../utils/RescriptJsonUtils.bs.js";
import * as LegacyShowside_ConfigurationDecoders$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/LegacyShowside/LegacyShowside_ConfigurationDecoders.bs.js";
function $$default(json) {
  performance.mark && performance.mark('Config.decode');
  var result = RescriptJsonUtils$Showside.decode(json, LegacyShowside_ConfigurationDecoders$ApiTypes.fromJson);
  performance.measure && performance.measure('Config.decode', 'Config.decode');
  return result;
}
export { $$default, $$default as default };
/* RescriptJsonUtils-Showside Not a pure module */